import React from "react";
import { Link } from "react-router-dom";
import { Clock, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function BuyerApprovalBanner() {
  const { user } = useAuth();
  if (!user || user.role === "admin" || user.status === "approved") return null;

  if (user.status === "rejected") {
    return (
      <div data-testid="rejected-banner" className="bg-rose-50 border-b border-rose-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center gap-3 text-sm text-rose-800">
          <XCircle className="h-5 w-5 shrink-0" />
          <span>
            Your wholesale account application was not approved. Please{" "}
            <Link to="/account" className="underline font-medium">contact our team</Link> to resubmit your details.
          </span>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="pending-banner" className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center gap-3 text-sm text-amber-800">
        <Clock className="h-5 w-5 shrink-0" />
        <span>
          <strong>Account pending verification.</strong> You can browse the catalogue, but wholesale
          prices, stock levels and ordering unlock once an admin approves your account.
        </span>
      </div>
    </div>
  );
}
